import React from 'react'

interface Datas {
  datas: {
    flamelinkContactContent: {
      alt: string
      width: number
      height: number
      video: {
        url: string
      }[]
    }
  }
}

const s = {
  video: `w-full h-h50 mb-20 object-cover mdm:h-h50 smm:h-h40 xsx:h-h32`,
}

const Image = ({ datas }: Datas) => {
  const { alt, width, height, video } = datas.flamelinkContactContent

  return (
    <video
      className={s.video}
      width={width}
      height={height}
      airia-label={alt}
      autoPlay
      loop
    >
      <source src={video[0].url} type="video/mp4" />
    </video>
  )
}

export default Image
